import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'; 
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import { signUp, checkedVerified } from '../../app/actions/authActions';
import { showAlert, hideAlert } from '../../app/actions/uiActions';
import Title from '../../components/Title';
import Input from '../../components/Input';
import Button from '../../components/Button';
import AlertMessage from '../../components/AlertMessage';
import { withAuthLayout } from '../../components/hocs/withAuthLayout';

const SignUp = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const [affidavit, setaffidavit] = useState(true);
	const uid = useSelector((state) => state.firebase.auth.uid);
	const isVerified = useSelector((state) => state.auth.isVerified);
	const approved = useSelector((state) => state.auth.approved);
	const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);
	const ui = useSelector((state) => state.ui);
	const [signUpState, setSignUpState] = useState({
		businessName: '',
		facilityAddress: '',
		position: '',
		firstName: '',
		lastName: '',
		email: '',
		password: '',
		confPassword: '',
		isVerified: false
	});

	const handleSubmit = (e) => {
		e.preventDefault();

		if(signUpState.password === signUpState.confPassword ) {
			setaffidavit(false);
		} else {
			dispatch(showAlert({type:'error', message: 'Password does not match'}))
		};
	};
	
	const handleChangeInput = ({id, value}) => {
		setSignUpState((state) => ({...state, [id]: value}));
	};

	const handleCertification = () => {
		const {confPassword, ...newUser} = signUpState;
		dispatch(signUp(newUser));
	};

	const handleRedirect = (event) => {
		event.preventDefault();
		history.push(`/${event.target.name}`);
	};
	
	useEffect(()=>{
		uid && dispatch(checkedVerified(uid));
		dispatch(hideAlert());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]); 

	useEffect(() => {
		if(uid && isVerified && approved) {
			history.push('/');
		};

		if(signUpSuccess) {
			history.push('/login');
		};

		if(!affidavit && ui.showAlert.type === 'error') {
			setaffidavit(true);
		};

		if(ui.showAlert.type === 'emailVerify' || ui.showAlert.type === 'approve') {
			dispatch(hideAlert());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[uid,isVerified,approved,signUpSuccess,ui.showAlert]);


	// useEffect(() => {
	// 	dispatch(hideAlert());
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// },[showAlertState]);

	// useEffect(()=>{
	// 	uid && dispatch(checkedVerified(uid));
	// 	dispatch(hideAlert());
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// },[]); 

	// useEffect(()=>{
	// 	if(!affidavit && showAlertState.type === 'error') {
	// 		setaffidavit(true);
	// 	};
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// },[showAlertState.type]); 

	// useEffect(() => {
	// 	if(uid && isVerified && approved) {
	// 		history.push('/');
	// 	};
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// },[uid,isVerified,approved]);

	// useEffect(()=>{
	// 	if(signUpSuccess) {
	// 		history.push('/login');
	// 	};
	// }); 

	return (
		<div className="auth__content">
			{
				affidavit ? (
					<>
					<Title text={'Sign Up'} isBig isBold/>
					<form 
						className="auth__form"
						onSubmit={handleSubmit}
					>
						<AlertMessage showAlert={ui.showAlert}/>
						<Input 
							value={signUpState.businessName}
							id='businessName'
							type='text' 
							label='business Name' 
							onChange={handleChangeInput}
							required 
						/>
						<Input 
							value={signUpState.facilityAddress}
							id='facilityAddress'
							type='text' 
							label='facility Address' 
							onChange={handleChangeInput}
							required 
						/>
						<Input 
							value={signUpState.position}
							id='position'
							type='text' 
							label='position' 
							onChange={handleChangeInput}
							required 
						/>
						<Input 
							value={signUpState.firstName}
							id='firstName'
							type='text' 
							label='first Name' 
							onChange={handleChangeInput}
							required 
						/>
						<Input 
							value={signUpState.lastName}
							id='lastName'
							type='text' 
							label='last Name' 
							onChange={handleChangeInput}
							required 
						/>
						<Input 
							value={signUpState.email}
							id='email'
							type='email' 
							label='email' 
							onChange={handleChangeInput}
							required 
						/>
						<Input 
							value={signUpState.password}
							id='password'
							type='password' 
							label='password'
							onChange={handleChangeInput}
							required
						/>
						<Input 
							value={signUpState.confPassword}
							id='confPassword'
							type='password' 
							label='Confirm Password'
							onChange={handleChangeInput}
							required
						/>

						<div className="auth__btn">
							<Button text='Sign me up!'/>
						</div>
					</form>
					<div 
						className="auth__btn auth__btn--sign-in" 
					>
						<a 
							href="/"
							className="auth__controls-item"
							name="login" 
							onClick={handleRedirect}
						>
							Login
						</a>
					</div>
					</>
				) : (
					<div className="auth__agreements">
						<Title text={'CERTIFICATION of USER (Health Care Provider, Business, User)'} isBig isBold/>
						<p className="auth__agreements-text">
							<span className="auth__agreements-name">{`${signUpState.firstName} ${signUpState.lastName}`}</span>, certifies that will be relied upon by G9 LLC, DBA “UNITYlink” in connection with the use of the UNITYlink Application (the “Application”).User hereby acknowledges, agrees, and undertakes to submit truthful, complete, and valid information (the “Information”) for use with the Application, and to the best of User‘s ability, User shall not furnish false or misleading Information.User covenants and agrees that User shall not alter the Information he/she provide or tamper with health-related documents (the “Documents”) that he/she will submit to G9 LLC in connection with the Application. If User fails to provide truthful, accurate and valid Information and Documents, User understands and acknowledges that by doing so, he/she may risk becoming ill or transmitting illness, and possibly risk death to User or others.User hereby releases,  and discharges UNITYlink and G9-LLC  and its successors, assigns, affiliates, agents, employees officers, and agents  from any actions, demands, claims, causes of action, suits, debts, costs, sums of money, obligations, accounts, liabilities, bonds, bills, covenants, contracts, agreements, losses, damages, judgments and executions whatsoever, whether known or unknown, liquidated or contingent, foreseeable or unforeseeable, direct or derivative, and whether or not alleged or made, in law, admiralty or equity for, upon or by reason of any matter, cause or thing whatsoever from the beginning of the world to the day of the date of this Certification.User further covenants and agrees that he/she shall not at any time hereafter assert, file, pursue or prosecute, or encourage, promote, seek or voluntarily participate or cooperate in the assertion, filing or prosecution of, any complaint, charge, claim, action or other proceeding on his/her behalf or on behalf of any person or entity against UNITYlink and G9-LLC  and its successors, assigns, affiliates, agents, employees officers, and agents  with respect to any matter, cause, or thing whatsoever which has been released pursuant to this Certification.  User shall indemnify and hold against UNITYlink and G9-LLC and its successors, assigns, affiliates, agents, employees officers, and agents harmless against any and all claims, demands, damages, liabilities and costs which directly or indirectly result from, or arise in connection with, any negligent act or omission of User, its agents, or employees, pertaining to any activities and obligations in connection with the Application or from the use thereof.
						</p>
						<Input 
							id='agreements'
							type='checkbox' 
							label="By checking this box I agree to the Certification above"
							onChange={handleCertification}
						/>
					</div>
				)
			}
		</div>
	);
};

export default withAuthLayout(SignUp);
